import { getSingleAsset, getSingleAssetId } from './selectors';
import { takeLatest } from '../../listenerMiddleware';
import * as fullscreenPreviewActions from './actions';
import * as api from '../../api';
import { Page } from '../router/model';
import { getPage } from '../router/selectors';
import { getSharingId } from '../sharing/selectors';

export const fullscreenPreviewListeners = () => {
  watchAssetIdChanged();
};

function watchAssetIdChanged() {
  takeLatest(
    fullscreenPreviewActions.assetIdChanged,
    async (action, { getState, dispatch, signal }) => {
      const assetId = getSingleAssetId(getState());
      const asset = getSingleAsset(getState());

      if (assetId && assetId !== asset?.id) {
        dispatch(fullscreenPreviewActions.assetChanged({ asset: null, error: false }));

        const page = getPage(getState());
        const sharingId = getSharingId(getState());

        const result = await api.loadAssetDetails(
          assetId,
          page === Page.sharing ? sharingId : undefined,
        );
        if (signal.aborted) {
          return;
        }

        if (result.success) {
          dispatch(
            fullscreenPreviewActions.assetChanged({ asset: result.data.response, error: false }),
          );
        } else {
          dispatch(
            fullscreenPreviewActions.assetChanged({
              asset: null,
              error: result.errorData?.status ?? true,
            }),
          );
        }
      }
    },
  );
}
